import React from 'react'
import { useTranslation } from 'react-i18next'
import { FontSizeOutlined } from '@ant-design/icons'
import { useGlobalThemeStore } from 'store/globalThemeStore/globalThemeStore'

import IconButtonWithTooltip from 'components/atoms/IconButtonWithTooltip/IconButtonWithTooltip'

import { StyledButtonsContainer } from './ChangeFontSizeButtons.styles'

const ChangeFontSizeButtons = () => {
    const [, { setFontSize }] = useGlobalThemeStore()
    const { t } = useTranslation()

    return (
        <StyledButtonsContainer>
            <li>
                <IconButtonWithTooltip
                    t={t('default_font_size')}
                    icon={<FontSizeOutlined />}
                    onClick={() => setFontSize('62.5%')}
                />
            </li>
            <li>
                <IconButtonWithTooltip
                    t={t('medium_font_size')}
                    icon={<FontSizeOutlined />}
                    onClick={() => setFontSize('80%')}
                />
            </li>
            <li>
                <IconButtonWithTooltip
                    t={t('large_font_size')}
                    icon={<FontSizeOutlined />}
                    onClick={() => setFontSize('100%')}
                />
            </li>
        </StyledButtonsContainer>
    )
}

export default ChangeFontSizeButtons
